import { darkGrey, mediumGrey } from '../const/colors'

export function actionText(theme, isGrey) {
  return {
    color: isGrey ? mediumGrey : theme.brandPrimary,
    cursor: 'pointer',

    '&:hover': {
      color: isGrey ? darkGrey : theme.brandPrimary
    }
  }
}

export function textEllipsis() {
  return {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}

export function textEllipsisMultiline(maxLines = 2) {
  return {
    lineClamp: maxLines,
    overflow: 'hidden',
    display: 'box',
    boxOrient: 'vertical'
  }
}
